/**
 * @Author maogangfeng
 * @Date 2020-03-16 16:32:29
 * @Desc 运营专员首页常量
 */
// 处置状态类型
export const STATISTICS_TYPE = {
  NOTCHECK: 3,
  OVERTIME: 2,
  NOTDEAL: 1,
  ALREADY: 5
}

// 处置状态
export const STATISTICS_TYPE_NAME = {
  [STATISTICS_TYPE.NOTCHECK]: '待审核',
  [STATISTICS_TYPE.OVERTIME]: '超期未处理',
  [STATISTICS_TYPE.NOTDEAL]: '未处理',
  [STATISTICS_TYPE.ALREADY]: '已完成'
}

// 图表标准色
export const COLORPICKER = ['#027FE1', '#00FFED', '#09C889', '#FFB023', '#FF3D1C', '#9287E7']

// 标准色透明度百分之10
export const COLORPICKERWITHALPHA = [
  '#027FE11A',
  '#00FFED1A',
  '#09C8891A',
  '#FFB0231A',
  '#FF3D1C1A',
  '#9287E71A'
]
